module.exports = __webpack_public_path__ + "static/media/air-berlin.f41b31f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/air-berlin.svg
// module id = 100
// module chunks = 3